<template>
  <div class="player-lobby">
    <div class="container">
      <h1>Thank you for your trust</h1>
      <p>
        Before we can start digging through our vastly enormous databases, we
        require a photo of everyone to be included in our search.
      </p>
    </div>

    <div class="photos">
      <div v-for="player in players" :key="player.id">
        <div @click="selection = player">
          <img :src="player.croppedImage" />
        </div>
        <button @click="$store.commit('DELETE_PLAYER', player.id)">
          Delete
        </button>
      </div>
      <button @click="addPlayer" class="icon-btn">+</button>
    </div>

    <div class="action-bar">
      <button @click="startSearch">Start Search</button>
    </div>

    <div v-if="selection" class="overlay">
      <div class="overlay-window">
        <EditPlayer @cancel="selection = null" :id="selection.id" />
      </div>
    </div>
    <button v-if="dev" @click="exportLib">Export</button>
  </div>
</template>

<script>
import EditPlayer from "./EditPlayer.vue";

export default {
  components: {
    EditPlayer,
  },
  data() {
    return {
      selection: null,
      dev: false,
    };
  },
  computed: {
    players() {
      return this.$store.state.players;
    },
  },
  methods: {
    addPlayer() {
      this.selection = { id: "new", imageData: "" };
    },
    exit() {
      this.$store.commit("RESET");
      this.$router.push({ name: "Home" });
    },
    startSearch() {
      this.$router.push({ name: "Game" });
    },
    exportLib() {
      const lib = JSON.stringify(
        this.$store.state.players.map((p) => ({
          id: p.id,
          croppedImage: p.croppedImage,
          landmarks: p.landmarks,
        }))
      );
      console.log(lib);
    },
  },
};
</script>

<style lang="scss" scoped>
.player-lobby {
  position: relative;
}

.photos {
  display: flex;
  margin: 0.5em 0;
  padding: 0 0.5em;
  overflow-x: scroll;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.overlay {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;

  .overlay-window {
    width: 100%;
    margin: 0 auto;
    margin: 2vmin;
    background-color: white;
    -webkit-box-shadow: 0 10px 6px -6px #777;
    -moz-box-shadow: 0 10px 6px -6px #777;
    box-shadow: 0 10px 6px -6px #777;
    overflow: auto;
    padding: 0.5em;
  }
}
</style>
